import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Headshot from "../img/headshot.png";

export const ExperienceSection = () => {
  return (
    <Container fluid className="experience-section" as="section">
      <Container>
        <Row className="experience-block" data-aos="fade-left">
          <Col sm="12" md="12" lg="9">
            <h2>Experience</h2>
            <p>
              I am a highly versatile drummer with over 15 years experience
              drumming in a wide variety of genres, I specialise in Jazz, Blues
              and Rock but I have also played in Metal, Pop and RnB bands too.
              <br />
              <br />
              I bring a unique flavour to my playing with flair and character, I
              can take a simple beat and give it groove and feeling through my
              use of beat accentuation and rhythm.
              <br />
              <br />I have also toured across the UK with a variety of different
              artists and have provided sessions work on a large number of
              albums, tracks and singles spanning a vast array of genres.
            </p>
            <a href="/about">
              Find Out More <FontAwesomeIcon icon={faChevronRight} />
            </a>
          </Col>
          <Col sm="12" md="12" lg="3">
            <Image
              className="w-75"
              src={Headshot}
              alt="Josh sitting on a backwards chair holding drumsticks"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
